import { COMPLETED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { getId } from 'customer-data-objects/record/ObjectRecordAccessors';
import { STATUS, TITLE } from 'customer-data-objects/task/TaskPropertyNames';
import { useCallback, useContext } from 'react';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UILink from 'UIComponents/link/UILink';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TableContext } from '../../context/TableContext';
import { useQueryParamString } from '../../hooks/useQueryParams';
import { useActiveViewId } from '../../hooks/viewTabs';
import { START_QUEUE_SOURCES } from '../../tracking/tracker';
import HoverComponent from './HoverComponent';
import { getTaskHistoryUrl } from '../../utils/links';
import { Flex } from 'foundations-components/components/Flex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskSubjectCell = ({
  original: task
}) => {
  const queryParamsString = useQueryParamString();
  const taskId = getId(task);
  const title = getProperty(task, TITLE);
  const {
    onStartTaskQueue
  } = useContext(TableContext);
  const activeViewId = useActiveViewId();
  const handleStartQueueWithTask = useCallback(() => onStartTaskQueue({
    task,
    source: START_QUEUE_SOURCES.TABLE_ROW
  }), [task, onStartTaskQueue]);
  const isTaskComplete = getProperty(task, STATUS) === COMPLETED;
  const taskTitle = isTaskComplete ? /*#__PURE__*/_jsx("s", {
    children: title
  }) : title;
  const wrappedTaskTitle = /*#__PURE__*/_jsx(Flex, {
    overflow: "hidden",
    flexShrink: 1,
    flexWrap: "nowrap",
    children: /*#__PURE__*/_jsx(UILink, {
      use: "dark",
      truncate: true,
      onClick: handleStartQueueWithTask,
      "data-selenium-test": "task-subject-cell-link",
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: taskTitle
      })
    })
  });
  return /*#__PURE__*/_jsx(HoverComponent, {
    "data-test-id": "tasks-hover-cell",
    "data-selenium-test": "task-subject-cell",
    "data-task-title": title,
    hoverContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIRouterButton, {
        size: "xs",
        to: `/view/${activeViewId}/task/${taskId}${queryParamsString}`,
        "data-selenium-test": "task-actions-edit-task-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tasks-table.cells.taskSubject.editTaskButtonLabel"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-selenium-test": "task-actions-history-button",
        external: true,
        href: getTaskHistoryUrl(taskId),
        size: "xs",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tasks-table.cells.taskSubject.taskHistoryButtonLabel"
        })
      })]
    })
    // @ts-expect-error role not defined on type
    ,
    role: "none",
    children: wrappedTaskTitle
  });
};
export default TaskSubjectCell;